import { render } from "./Zwsj.vue?vue&type=template&id=11fd8610"
import script from "./Zwsj.vue?vue&type=script&lang=js"
export * from "./Zwsj.vue?vue&type=script&lang=js"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__